<div class="container">
    <div class="left-section">
      <mat-form-field appearance="fill" class="import-form-field">
        <mat-select class="custom-backdrop-class import-panel " panelClass="import-select" [(ngModel)]="proType"
          (ngModelChange)="setProType()">
          <mat-option *ngFor="let type of proTypes" [value]="type">{{type}}</mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-form-field appearance="fill" class="import-form-field">
        <mat-select class="custom-backdrop-class import-panel " panelClass="import-select" [(ngModel)]="proYear"
          (ngModelChange)="setProYear()">
          <mat-option *ngFor="let year of proYears" [value]="year">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-radio-group class="import-quarters" aria-label="Select Quarter" [(ngModel)]="proQuarter"
        (ngModelChange)="setProQuarter()">
        <mat-radio-button *ngFor="let quarter of proQuarters" [value]="quarter">{{quarter}}</mat-radio-button>
      </mat-radio-group>
      <button class="action-button" style="margin-left: 14px;" (click)="onGetProsClick()">GET PRO</button>
    </div>
  
    <div class="right-section">
      <button id="filter-button" class="action-button" (click)="showFilterPanel()"><app-filter-panel-icon></app-filter-panel-icon></button>
      <button id="export-button" class="action-button" (click)="exportPro()">Export <app-upload-icon [stroke]="'white'"></app-upload-icon></button>
      <div *ngIf="importExists" style="display: flex;">
        <span id="pro-status" *ngIf="proStatus" class="status-container"><app-status-dot-icon [status]="proStatus"></app-status-dot-icon> {{proStatus}} </span>
        <button id="approve-button" class="action-button" (click)="approvePro()">Approve</button>
        <button id="export-button" class="action-button" (click)="exportPro()">Export <app-upload-icon [stroke]="'white'"></app-upload-icon></button>
      </div>
      <!-- <button *ngIf="!importExists" id="import-button" (click)="openProImport()">Import PRO</button> -->
      <!-- <button *ngIf="!importExists" id="import-button" (click)="openProImport()">Import PRO</button> -->
    </div>
  </div>